

/**
 * @return env: {
        device: { // 设备
            val: 1,
            name: 'android',
            isAndroid: true/false
            isIOS: true/false,
            isOther: true/false
        }, 
        platform: { // SNS平台
            val: 1,
            name: 'pengpeng',
            isPengpeng: true/false
            isIOS: true/false,
            ...
        },
        env: '' // 当前开发环境：pro/stage
    }
 */
define(function (require, exports, module) {

    var Url = require('c-url');

    var ua = window.navigator.userAgent;
    var Env = {
        platform: {},
        device: {},
        env: 'pro'
    };

    // $('#wrap').html(ua)
    //  当前设备
    if (ua.match(/pengpeng/i)) {
        // 碰碰
        Env.platform = {
            val: 2001,
            name: 'pengpeng',
            isPengpeng: true
        };
    } else if (ua.match(/uplive/i) || Url.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || Url.query('pl') == 'uplive') {
        Env.platform = {
            val: 2002,
            name: 'uplive',
            isUplive: true
        };
    } else if (ua.match(/duobao/i)) {
        Env.platform = {
            val: 2003,
            name: 'duobao',
            isDuobao: true
        };
    } else if (ua.match(/micromessenger/i)) {
        // 微信
        Env.platform = {
            val: 1,
            name: 'wechat',
            isWeixin: true
        };
    } else if (ua.match(/qq\//i) || ua.match(/and_sq_/i)) {
        // QQ
        Env.platform = {
            val: 4001,
            name: 'qq',
            isQQ: true
        };
    } else if (ua.match(/weibo/i)) {
        // 微博
        Env.platform = {
            val: 8001,
            name: 'weibo',
            isWeibo: true
        };
    } else if (ua.match(/[Tt]witter/i)) {
        // twitter
        Env.platform = {
            val: 2,
            name: 'twitter',
            isTwitter: true
        };
    } else if (ua.match(/FB_IAB/i)) {
        // facebook
        Env.platform = {
            val: 3,
            name: 'facebook',
            isFacebook: true
        };
    } else if (ua.match(/Line/i)) {
        Env.platform = {
            val: 4,
            name: 'line',
            isLine: true
        };
    } else {
        Env.platform = {
            val: 0,
            name: 'unknown',
            isOther: true
        };
    }
    // 当前社交环境
    if (Env.platform.isPengpeng) {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        }
    } else {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        } else {
            Env.device = {
                val: 3,
                name: 'unknown',
                isOther: true
            };
        }
    }

    // 当前开发环境
    var _env = Url.query('env');

    if (!_env || _env == 'null') {
        Env.env = 'pro';
    } else {
        Env.env = _env;
    }

    module.exports = Env;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-nenv/dist/index.js
// module id = 82
// module chunks = 0 1